import { render, staticRenderFns } from "./RelatedProductsOne.vue?vue&type=template&id=44af8d24&"
import script from "./RelatedProductsOne.vue?vue&type=script&lang=js&"
export * from "./RelatedProductsOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44af8d24')) {
      api.createRecord('44af8d24', component.options)
    } else {
      api.reload('44af8d24', component.options)
    }
    module.hot.accept("./RelatedProductsOne.vue?vue&type=template&id=44af8d24&", function () {
      api.rerender('44af8d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/related/RelatedProductsOne.vue"
export default component.exports